import { useEffect } from 'react'
import { FiX } from 'react-icons/fi'
import pdBuddyIcon from '@presentation/assets/images/pd-buddy-icon.png'

interface RecommendedActivitiesSignupModalProps {
  isOpen: boolean
  onClose: () => void
}

export default function RecommendedActivitiesSignupModal({
  isOpen,
  onClose,
}: RecommendedActivitiesSignupModalProps) {
  useEffect(() => {
    if (!isOpen) {
      return
    }

    function handleEscape(event: KeyboardEvent) {
      if (event.key === 'Escape') {
        onClose()
      }
    }

    window.addEventListener('keydown', handleEscape)
    return () => {
      window.removeEventListener('keydown', handleEscape)
    }
  }, [isOpen, onClose])

  if (!isOpen) {
    return null
  }

  return (
    <div className="fixed inset-0 z-60 bg-black/55">
      <button
        type="button"
        className="absolute inset-0"
        aria-label="Close recommended activities modal"
        onClick={onClose}
      />

      <div className="relative z-10 flex h-full w-full items-center justify-center p-4 md:p-6">
        <section
          role="dialog"
          aria-modal="true"
          aria-label="PD Buddy sign up"
          className="relative w-full max-w-md rounded-2xl bg-blue text-white shadow-2xl"
        >
          <button
            type="button"
            onClick={onClose}
            aria-label="Close recommended activities modal"
            className="absolute right-4 top-4 inline-flex h-10 w-10 items-center justify-center rounded-lg text-white transition-colors hover:bg-white/15"
          >
            <FiX className="h-6 w-6" />
          </button>

          <div className="px-6 py-8 md:px-7 md:py-9">
            <h3 className="text-2xl font-bold">Recommended Activities</h3>
            <p className="mt-3 text-sm leading-relaxed text-white/90 sm:text-base">
              Sign up for the free PD Buddy App and enjoy full access to our library, plus so much more!
            </p>

            <div className="mt-6 flex justify-center">
              <a
                href="https://pdbuddy.app/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-3 rounded-xl bg-pdbuddy-background px-4 py-3 font-semibold text-primary no-underline transition-colors hover:bg-[#f2e8dc]"
              >
                <img
                  src={pdBuddyIcon}
                  alt="PD Buddy"
                  className="h-10 w-10 rounded-md object-cover"
                />
                <span>PD Buddy App</span>
              </a>
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}
